var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NewsTabs'),_c('div',{staticClass:"p-4 text-center anim-fade-in"},[_c('h2',[_vm._v("DAILY NEWSPAPER")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.news)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }